angular = require('angular')

app = angular.module('workflow.app')
app.directive('multiSelectFacet', require('./MultiSelectFacet'))
app.directive('multiSelectFacetItem', require('./MultiSelectFacetItem'))
